/* @flow */
import apiRequest from 'lib/apiRequest';
import Collection from 'lib/Collection';
import Invitation from 'entities/Invitation';

export type Recipient = {
  address: string,
  name: string,
  isOver13?: boolean,
  role?: string,
};

class Invitations extends Collection<Invitation> {
  initialize() {
    this.model = Invitation;
  }

  static invite(groupId: Backbone$Id, recipients: Recipient[]) {
    return apiRequest(`/classes/${groupId}/invitations`, 'POST', {
      invitations: recipients.map(recipient => {
        return {
          address: recipient.address,
          name: recipient.name,
        };
      }),
    });
  }

  static inviteIndividual(groupId: Backbone$Id, recipient: Recipient) {
    return apiRequest(`/classes/${groupId}/invitations`, 'POST', {
      invitation: {
        recipient: recipient.address,
        name: recipient.name,
        not_child: recipient.isOver13,
        role: recipient.role,
      },
    });
  }
}

export default Invitations;
